import {AppManifestBuilder} from '@wix/yoshi-flow-editor'
import membersPageConfig from '../../components/members-page/.component.json'

export const membersPageBuilder = (appManifestBuilder: AppManifestBuilder) => {
  return appManifestBuilder.configureWidget(membersPageConfig.id, widgetBuilder => {
    widgetBuilder.gfpp().set('widgetPlugins', {behavior: 'HIDE'})
    widgetBuilder.behavior().set({removable: false})
  })
}
